import { Box } from '@chakra-ui/react';

const GradientBorderCard = ({
  children,
  gradient = 'linear-gradient(180deg, #FF9554 16%, #FF4935 100%)',
  borderPadding = '1.5px',
  bg = 'gradientOrange',
  p = 8,
  borderRadius = '15px',
  ...boxProps
}) => {
  return (
    <Box
      position="relative"
      borderRadius={borderRadius}
      bg={bg}
      p={p}
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        padding: borderPadding,
        borderRadius: 'inherit',
        background: gradient,
        WebkitMask:
          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude',
        pointerEvents: 'none',
      }}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

export default GradientBorderCard;
